module.exports = __webpack_public_path__ + "static/img/15b.642d009.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/15b.png
// module id = OPPx
// module chunks = 1